import React, { useState } from 'react';
import { useEffectOnce } from '../../hooks/useEffectOnce';
import { useApptekster } from '../../contexts/ApptekstContext';
import { hentKjennemerkeBaseUrl } from '../../utils/api';
import { SVVSpinner } from '@komponentkassen/svv-spinner';
import { SVVButtonLink } from '@komponentkassen/svv-button';

type LastNedFilProps = {
    rettighetId: number;
};

export const LastNedFil: React.FC<LastNedFilProps> = ({ rettighetId }) => {
    const t = useApptekster();
    const [kjennemerkeUrl, setKjennemerkeUrl] = useState<string>();

    useEffectOnce(() => {
        const hentKjennemerkeUrl = async () => {
            setKjennemerkeUrl(await hentKjennemerkeBaseUrl(`${rettighetId}`));
        };
        hentKjennemerkeUrl();
    });

    if (kjennemerkeUrl) {
        return (
            <SVVButtonLink
                download="kjennemerkebevis.pdf"
                href={kjennemerkeUrl}
            >
                {t('personlig-kjennemerke.knytt.last-ned-bevis')}
            </SVVButtonLink>
        );
    }

    return (
        <div aria-live="polite">
            <SVVSpinner size="small" centered={false}>
                {t('personlig-kjennemerke.delt.laster')}
            </SVVSpinner>
        </div>
    );
};
